import { logger } from '@atc/syndicated-logging';

logger.configure({ level: logger.logLevel.DEBUG });
const featureLogger = logger.getLogger();

export default function applyFlags(featureFlags = {}, dataFeatureFlags) {
    const { searchParams } = new URL(window.location.href);
    const forceFeatures = searchParams.get('forceFeatures');

    let parsedForceFeatures = {};
    if (forceFeatures) {
        try {
            parsedForceFeatures = JSON.parse(forceFeatures);
        } catch (e) {
            // no-op
            featureLogger.warn('Unable to parse forceFeatures query value into a JSON object', e);
        }
    }

    let parsedFeatureFlags = {};
    if (dataFeatureFlags) {
        try {
            parsedFeatureFlags = JSON.parse(dataFeatureFlags);
        } catch (e) {
            // no-op
            featureLogger.warn('Unable to parse data-feature-flags value into a JSON object', e);
        }
    }
    // Adding this to enable confirmation on what flags are being applied
    const appliedFlags = { ...featureFlags, ...parsedFeatureFlags, ...parsedForceFeatures };
    featureLogger.debug('Applied feature flags:', appliedFlags);
    return appliedFlags;
}
